import { fetch } from "src/services/apollo-fetch";
import { Query } from "../_api";

export default {
    async fetchAllUnits({ commit }, { excludeAvailableWhenZero }) {
        const response = await fetch.query({
            query: Query.allUnits,
            variables: { excludeAvailableWhenZero },
        });
        commit("setAllUnits", response.data.allUnits);
    },
};
